jQuery(document).ready(function($){
    $(".pushy__container").prepend("<a href='#' class='pushy-close pushy-link'>Close</a>");
    $(".pushy__container").on("click", ".pushy-close", function(){
       $("body").removeClass("pushy-open-right");
    });
});